import { Form, Input } from 'antd';
import React from 'react'

const InputUC = (props) => {
    const {
        name,
        label,
        isCustomError = false,
        labelError = null,
        showLabel = true,
        type = "text",
        onChange,
        values,
        maxLength,
        suffix,
        required,
        disabled,
        hidden,
        mask,
        placeholder = 'กรุณากรอก' + label,
        showPlaceholder = true,
        rules = null,
        className,
        onKeyPress,
        ref,
        autoComplete = 'off',
        ...prop } = props;
    const _maxLength = maxLength
        ? maxLength
        : name
            ? name.toLowerCase().includes("code")
                ? "50"
                : name.toLowerCase().includes("name")
                    ? "255"
                    : name.toLowerCase().includes("description")
                        ? "500"
                        : "100"
            : "100";

    return (
        <>
            <Form.Item
                name={name}
                label={showLabel ? (label + ' :') : ''}
                style={hidden ? { height: '0', visibility: 'hidden' } : { height: 'auto' }}
                rules={rules ? rules : required ? [{
                    required: true,
                    message: 'กรุณากรอก ' + label
                }, {
                    validator: (_, value) =>
                        (typeof (name) === 'string' && name.toString().toLowerCase().includes("code")) ? (
                            !value || !value.toString().includes(' ')
                                ? Promise.resolve()
                                : Promise.reject(new Error(label + ' ไม่สามารถมีช่องว่าง'))
                        ) : Promise.resolve()
                }] : ''
                }
                validateStatus={(isCustomError && required) ? 'error' : undefined}
                help={(isCustomError && required) ? labelError : null}
                initialValue={values ? values : ''}
                className={className}
            >
                <Input
                    {...prop}
                    className={'input-text-rc'}
                    ref={ref}
                    mask={mask}
                    type={type}
                    disabled={disabled}
                    onChange={onChange}
                    maxLength={_maxLength}
                    autoComplete={autoComplete}
                    placeholder={showPlaceholder ? placeholder : ''}
                    suffix={suffix ? suffix : ''}
                    onKeyPress={onKeyPress ? onKeyPress : (ev) => {
                        if (ev.key === "Enter" || (ev.key === " " && name.toLowerCase().includes("code"))) {
                            ev.preventDefault();
                            console.log(ev.target.value);
                        }
                    }}
                />
            </Form.Item>
        </>
    )
}

export default InputUC